import { useSyncExternalStore } from "react";

const query = "(max-width: 768px) and (hover: none) and (pointer: coarse)";

export const mobileMedia = `@media ${query}`;

function subscribe(callback: () => void) {
  const mql = window.matchMedia(query);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.matchMedia(query).matches;
}

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
